//Imports

import React from "react";
import picture from "./content/startpage_image.png"
import "./pages.css"
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Footer from "../components/footer";




//Function Start
export default function Start(){

    //Declarations & Functions inside the function

    let navigate = useNavigate()

    const redirectintern = () => { //Redirects the button to the intern page
        navigate("/intern/login")
    }


    //Popup Window
/*
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    const [open, setOpen] = React.useState(false); // If this is true -> pops out automatically at the loading!

    const handleClickOpen = () => {
            setOpen(true);
        };

    const handleClose = () => {
            setOpen(false);
        };

*/
    //Rendered Parts starts

    return(
        <div>
            <div className="container">
                <img src={picture} className="center-fit" width="auto" height="auto" alt="Logo" />
                <Button className="btn" onClick={redirectintern}>Interner Bereich</Button>
                <div>
                    {
                        //Insert Button if initial state is false -> Pop up is not loaded automatically!
                    }
                    {/*   <Dialog
                  open={open}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={handleClose}
                  aria-describedby="alert-dialog-slide-description"
              >
                  <DialogTitle className="Start-Options">{"Herzlich Willkommen auf der Website der Familie Muscholl!"}</DialogTitle>
                  <DialogContent className="Start-Options">
                      <DialogContentText  className="Start-Options" sx={{color: "#ffffff"}}>
                          Wie möchten Sie fortfahren?
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions className="Start-Options">
                      <Button sx={{background: "transparent", color: "#ffffff", borderColor: "#ffffff"}} variant="outlined" onClick={redirectintern}>Interner Bereich</Button>
                      <Button sx={{background: "black", color: "#ffffff", "&:hover":{ backgroundColor: "#ba10d1"}}} onClick={handleClose} >Website</Button>
                  </DialogActions>
              </Dialog> */}
                    <p className={"versiontag"}>v0.1.7</p>
                </div>

            </div>

        </div>


    );

}